function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Balance-app",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tablet---Energie-gebouw-Energieverbruik",
  transform: "translate(-926.000000, -305.000000)",
  stroke: "#FFFFFF",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("g", {
  id: "Filter--Copy",
  transform: "translate(859.000000, 256.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "gas-wit",
  transform: "translate(68.000000, 49.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.33333333,12.5 C3.33333333,14.3409492 4.8257175,15.8333333 6.66666667,15.8333333 C8.50761583,15.8333333 10,14.3409492 10,12.5 C9.88475644,10.3206214 8.99869236,8.2531386 7.5,6.66666667 L5.83333333,10.8333333 L4.16666667,9.16666667 C3.66801592,10.2105978 3.38460909,11.3442251 3.33333333,12.5 L3.33333333,12.5 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,12.5 C0,16.1818983 2.98476833,19.1666667 6.66666667,19.1666667 C10.348565,19.1666667 13.3333333,16.1818983 13.3333333,12.5 C13.3333333,5.83333333 7.5,0.833333333 7.5,0.833333333 L5,5 L3.33333333,3.33333333 C1.32690014,5.98481821 0.165366307,9.17903625 0,12.5 Z",
  id: "Path"
})))));
function SvgGasSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gas-wit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasSelected);
export default __webpack_public_path__ + "static/media/Gas_selected.99363587362469c630a7656d8eb78ffd.svg";
export { ForwardRef as ReactComponent };